import type { FilterField } from '@/components/common/AdvancedFilter';
import type { FeedbackType } from '@/features/feedbackTypes/types/feedbackType.types';
import { FEEDBACK_STATUS, FEEDBACK_STATUS_LABELS } from '../constants/feedback.constants';
import type { FeedbackFilters } from '../types/filters.types';

interface GetFeedbackListFilterFieldsArgs {
  feedbackTypes: FeedbackType[] | undefined;
  filters: FeedbackFilters;
}

export function getFeedbackListFilterFields({
  feedbackTypes,
  filters,
}: GetFeedbackListFilterFieldsArgs): FilterField[] {
  return [
    {
      key: 'typeId',
      label: 'Type',
      type: 'select',
      placeholder: 'All Types',
      options:
        feedbackTypes
          ?.filter((type) => type.isActive)
          .map((type) => ({ label: type.name, value: String(type.id) })) ?? [],
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      placeholder: 'All Statuses',
      options: FEEDBACK_STATUS.map((status) => ({
        label: FEEDBACK_STATUS_LABELS[status],
        value: status,
      })),
    },
    {
      key: 'startDate',
      label: 'From',
      type: 'date',
    },
    {
      key: 'endDate',
      label: 'To',
      type: 'date',
      ...(filters.startDate ? { minDate: filters.startDate } : {}),
    },
  ];
}
